import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faDownload } from "@fortawesome/free-solid-svg-icons";
import {
  Button,
  Modal,
  Form,
  Card,
  Table,
  Nav,
  Pagination,
} from "@themesberg/react-bootstrap";
import { getFiles, createFile, downloadFile } from "../../app/api";
import axios from "axios";
import Loader from "../../components/Loader";
import swal from "sweetalert";
import ButtonLoader from "../../components/ButtonLoader";
import Loadericon from "../../components/Loadericon";
import moment from 'moment'
export default () => {
  const [show, setShow] = useState(false);
  const [FileManagement, setFileManagement] = useState([]); // State to hold vendor data
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0); // State to hold total pages
  const [page, setPage] = useState(1);
  //  const[category,setCategory]=useState("")
  const [title, setTitle] = useState("");
  const [file, setFile] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [downloadingFileId, setDownloadingFileId] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingBtn(true);
    try {
      const token = localStorage.getItem("token");

      const formData = new FormData();
      formData.append("category", "Vendor");
      formData.append("title", title);
      formData.append("file", file);

      const response = await axios.post(createFile(), formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Important for file uploads
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });

      swal({
        text: response.data.message,
        icon: "success",
      });
      setTitle("");
      setFile("");
      setShow(false);
      // console.log(response.data);
    } catch (error) {
      swal({
        text: error.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
     
      fetchFilemanagment(page);
    
    }
  };
  const handleDownload = async (id, files) => {
    setDownloadingFileId(id);
    try {
      const token = localStorage.getItem("token");

      // Make the API call to get the file
      const response = await axios.get(downloadFile(id), {
        responseType: "blob", // Important: Set responseType to 'blob' to handle binary data
        headers: {
          "Content-Type": "multipart/form-data",
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });

      // Find the file metadata from the `files` array
      const fileMetadata = files.find((file) => file.id === id);
      const originalName =
        fileMetadata?.title_with_extension || "downloaded_file";

      // Create a Blob from the response data
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      // Create a link element to trigger the download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = originalName; // Use the original_name from the metadata

      // Append the link to the DOM, trigger the download, and remove the link
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Show a success message
      swal({
        text: "File Downloaded Successfully",
        icon: "success",
      });
    } catch (error) {
      // Show an error message if something goes wrong
      swal({
        text:
          error.response?.data?.message ||
          "An error occurred while downloading the file",
        icon: "error",
      });
    } finally {
      setDownloadingFileId(null); // Reset the downloading state
    }
  };
  const fetchFilemanagment = async (currentPage) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getFiles(), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
        params: {
          page: currentPage, // Send the current page as a query parameter
        },
      });
      // console.log(response.data);

      setFileManagement(response.data?.files);
      setTotalPages(response.data?.pagination?.total_pages);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchFilemanagment(page);
  }, [page]);
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block  mb-xl-0">
              {/* <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
        <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
        <Breadcrumb.Item active>File Management</Breadcrumb.Item>
      </Breadcrumb> */}
              <h4 className="mb-0">File Management</h4>
              {/* <p className="mb-0">
       This is the File Management page
      </p> */}
            </div>
            <Button variant="primary" className=" me-2" onClick={handleShow}>
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              <span>New</span>
            </Button>
          </div>
          <Modal
            style={{ top: "15%" }}
            show={show}
            onHide={handleClose}
            scrollable
          >
            <Modal.Header closeButton>
              <Modal.Title>Add File</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group id="title">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter Title"
                  value={title} // Bind to state
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Form.Group>
              
              <div className="mb-3 mt-2">
                <label for="formFile" className="form-label">
                  Upload File
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="formFile"
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={handleClose}>
                Close
              </Button>
              {loadingBtn ? (
                <div className="d-flex justify-content-start">
                  <ButtonLoader />
                </div>
              ) : (
                <Button variant="primary" onClick={handleSubmit}>
                  Save changes
                </Button>
              )}
            </Modal.Footer>
          </Modal>
          <Card border="light"   className="table-wrapper table-responsive shadow-sm">
            <Card.Body className="p-0">
              <Table
                responsive
                className="user-table align-items-center"
              >
                <thead >
                  <tr>
                    <th className="border-0">Title</th>
                    <th className="border-0">Name</th>
                    <th className="border-0">Date time</th>
                    <th className="border-0">Added by</th>
                    <th className="border-0">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {FileManagement.map((files) => {
                    return (
                      <tr>
                        <td className="fw-bold">{files?.title}</td>
                        <td>{files?.title_with_extension}</td>
                        <td>{moment(files?.created_at).format("MM/DD/YYYY HH:mm")}</td>
                        <td>{files?.added_by_name}</td>
                        <td>
                          {downloadingFileId === files?.id ? ( // Check if this file is being downloaded
                            <div className="d-flex justify-content-start h-3">
                              <Loadericon />
                            </div>
                          ) : (
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleDownload(files?.id, FileManagement)
                              }
                            >
                              <FontAwesomeIcon icon={faDownload} />
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-center">

<Nav className="justify-content-center mb-4">
  <Pagination className="mb-2 mb-lg-0">
    <Pagination.Prev
      onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
    />
    {Array.from({ length: totalPages }, (_, index) => (
      <Pagination.Item
        key={index + 1}
        active={index + 1 === page}
        onClick={() => setPage(index + 1)}
      >
        {index + 1}
      </Pagination.Item>
    ))}
    <Pagination.Next
      onClick={() =>
        setPage((prev) => Math.min(prev + 1, totalPages))
      }
    />
  </Pagination>
</Nav>
</Card.Footer>
            </Card.Body>
          </Card>
        
          
        </div>
      )}
    </>
  );
};
